/** Адрес продового сайта: из него строятся canonical, og:url, sitemap и картинки для соцсетей */
export const SITE_URL = 'https://dnd5.su';
export const SITE_NAME = 'dnd5.su';
/** Редакция правил так, как её ищут: пишется в заголовках страниц (без года) */
export const EDITION = 'D&D 5e';
/** Что дописывается в описания: год редакции в заголовок не попадает, а ищут его часто */
export const RULES_NOTE = 'по правилам 2024';

export function absoluteUrl(path: string): string {
	if (/^https?:\/\//.test(path)) return path;
	return `${SITE_URL}${path.startsWith('/') ? '' : '/'}${path}`;
}

/** Путь без query-строки, якоря и завершающего слеша — именно он каноничный */
export function cleanPath(asPath: string): string {
	const path = asPath.split(/[?#]/)[0] || '/';
	return path.length > 1 ? path.replace(/\/+$/, '') : path;
}

export type OgKind =
	| 'section'
	| 'spell'
	| 'monster'
	| 'item'
	| 'feat'
	| 'origin'
	| 'specie'
	| 'class'
	| 'subclass'
	| 'feature'
	| 'glossary'
	| 'wiki';

export const OG_IMAGE_WIDTH = 1200;
export const OG_IMAGE_HEIGHT = 630;

/** Содержимое сгенерированной картинки для соцсетей */
export type OgCardData = {
	/** что это: «Заклинание», «Чудовище»… */
	label: string;
	title: string;
	originalTitle?: string | null;
	/** короткая строка метаданных: «1-й круг · Эвокация» */
	subtitle?: string | null;
};

export function ogImageUrl(kind: OgKind, id: string): string {
	return absoluteUrl(`/api/og/${kind}/${encodeURIComponent(id)}`);
}
